export default __webpack_public_path__ + "static/international_transport.png";